import React, { useMemo } from 'react'
import {
  LegacyFormikDropdown,
  LegacyFormikDropdownOption,
  LegacyFormikDropdownOptionValues,
} from '@babylon/core-ui'
import SlotTypeLabels, { SlotTypeName } from '../../types/SlotTypes'

interface SlotTypeLabelProps {
  value: SlotTypeName
  label?: string
}

export const SlotTypeLabel = ({ value, label }: SlotTypeLabelProps) => (
  <span>
    <span>{label || SlotTypeLabels[value]}</span>
  </span>
)

interface Props {
  className?: string
  disabled?: boolean
  slotTypeList: SlotTypeName[]
  onChange: (option: LegacyFormikDropdownOptionValues | null) => void
}

export default function AppointmentSlotTypeSelector({
  className,
  onChange,
  slotTypeList,
  disabled,
}: Props) {
  // slotTypeOptions return an empty array if slotTypeList is empty or undefined
  // returning an empty array prevents the dropdown from rendering
  const slotTypeOptions = useMemo(
    () =>
      slotTypeList.map((value) => ({
        value: value === 'public' ? 'digital' : value,
        label: SlotTypeLabels[value],
      })),
    [slotTypeList]
  )

  return (
    <div className={className} data-testid="appointment-slot-type-selector">
      <LegacyFormikDropdown
        id="slot_type"
        name="slot_type"
        label="Slot Type"
        options={slotTypeOptions}
        onChange={(option: LegacyFormikDropdownOption | null) =>
          onChange(option?.value || null)
        }
        valueRenderer={SlotTypeLabel}
        disabled={disabled}
        searchable={false}
        optionRenderer={SlotTypeLabel}
      />
    </div>
  )
}
